/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import dayjs from 'dayjs';
import { isLightColor } from '../../utils/color_helpers';

const TYPE_COLORS = {
  employee: {
    background: '#ffe5d6',
    color: '#ff6b2c',
  },
  investor: {
    background: '#efd9ff',
    color: '#8a3ffc',
  },
};

const DEFAULT_TYPE_COLOR = {
  background: '#e9eef5',
  color: '#556476',
};

export const getReadableTextColor = (color) => {
  return isLightColor(color?.toLowerCase?.()) ? '#16202c' : '#ffffff';
};

export const getTypeColor = (type) => {
  const normalizedType = String(type || '').trim().toLowerCase();
  return TYPE_COLORS[normalizedType] || DEFAULT_TYPE_COLOR;
};

export const formatDisplayLabel = (value) => {
  const label = typeof value === 'string' ? value : value?.title || value?.name || value?.label || '';
  return label || '-';
};

export const formatJoiningDate = (date) => {
  if (!date) {
    return '-';
  }

  return dayjs(date).isValid() ? dayjs(date).format('MMM YYYY') : '-';
};
